import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// @ts-ignore
// eslint-disable-next-line import/no-extraneous-dependencies,ordered-imports/ordered-imports
import { Howl } from 'howler';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { MenuIcon } from '../../icons';

import { StyledHeader, StyledHeadline } from './styled';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const goToMainAudio = new Howl({
    src: ['./audios/interaction-sounds/nav-to-overview-1.mp3'],
    volume: 0.01,
  });
  return (
    <StyledHeader>
      <Grid>
        <Container.FullBleed>
          <Cell.Basic colStarts={[1, 1, 2]} colSpan={[2, 4, 9]}>
            <StyledHeadline
              headline="The Contour of Stars"
              subHeadline="Emmanuel Witzthum"
              size="xl"
            />
          </Cell.Basic>
          <Cell.Basic colSpan={2}>
            {location.pathname !== '/' && (
              <button
                type="button"
                onClick={() => {
                  goToMainAudio.play();
                  navigate('/');
                }}
              >
                <MenuIcon />
              </button>
            )}
          </Cell.Basic>
        </Container.FullBleed>
      </Grid>
    </StyledHeader>
  );
};

export default Header;
